import React, { useMemo } from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { useTheme } from '@cp/ds/src/hooks';
import Shield from '../../../../../assets/shapes/shield.svg';
import { AchivementsProps } from './model';

export const Achievement = (props: AchivementsProps) => {
  const theme = useTheme();

  const icon = useMemo(() => {
    switch (props.type) {
      case 'verified':
        return (
          <Box sx={{ width: { xs: '16px', md: '20px' }, display: 'flex', alignItems: 'center' }}>
            <Shield />
          </Box>
        );
      case 'online':
        return <Box sx={{ height: '8px', width: '8px', backgroundColor: '#6AD059', borderRadius: 10 }} />;
      case 'school':
        return null;
      default:
        return '';
    }
  }, [props.type]);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: 'white',
        alignItems: 'center',
        border: `1px solid ${theme.palette['gray middle']}`,
        borderRadius: '6px',
        width: { xs: '28px', md: '32px' },
        height: props.type === 'online' ? { xs: '16px', md: '20px' } : { xs: '28px', md: '32px' },
        px: 1,
      }}
    >
      {icon}
    </Stack>
  );
};
